import { Button } from "../../../../components/ui";
import { useTranslation } from "../../../../i18n";

export function OperatorLoading() {
  const { t } = useTranslation();
  return (
    <div role="status" className="space-y-4 py-5">
      <p className="text-sm text-on-surface-variant">{t("operatorAdmin.loading")}</p>
      {[1, 2, 3].map((row) => (
        <div
          key={row}
          aria-hidden="true"
          className="h-20 rounded-xl border border-outline-variant bg-surface-container-low"
        />
      ))}
    </div>
  );
}

export function OperatorError({
  onRetry,
  stale = false,
}: {
  onRetry: () => void;
  stale?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-outline-variant bg-error-container p-4 text-on-error-container"
    >
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">
          {t(`operatorAdmin.portal.${stale ? "staleTitle" : "errorTitle"}`)}
        </p>
        <p className="mt-1 text-xs leading-relaxed">
          {t(`operatorAdmin.portal.${stale ? "staleHint" : "errorHint"}`)}
        </p>
      </div>
      <Button variant="secondary" onClick={onRetry}>
        {t("operatorAdmin.retry")}
      </Button>
    </div>
  );
}

export const operatorSelectClass =
  "min-h-11 w-full rounded-lg border border-outline bg-surface-container-low px-3 text-sm text-on-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50";
export const operatorLinkClass =
  "inline-flex min-h-11 items-center gap-2 rounded-lg text-sm font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50";
